let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4qJFV")).then(() => parcelRequire('jgSdJ'));